module.exports = __webpack_public_path__ + "static/media/linkedin.44e0d9a0.svg";